import React from 'react'
import './VideoHero.scss'
import {graphql} from 'gatsby'
import qrcode from '../../assets/pro-qr-code.png'

export default function VideoHero({text, button, title, video}) {
	return(
		<section className="VideoHero">
			<div className="VideoHero-text">
				<h1>{title}</h1>
				<p>{text}</p>
				{
					button &&
					<>
						<a href={button.url} target={button.target} className="Button primary-white"><span>{button.title}</span></a>
						<div className="qr-code">
							<p>Gå til mobilversjonen</p>
							<img width="150" src={qrcode} alt="QR code" />
						</div>
					</>
				}
			</div>
			<div className="video">
				{
					video && video.localFile && video.localFile.publicURL
					? 	<video autoPlay muted loop playsInline>
							<source src={video.localFile.publicURL} type="video/mp4" />
						</video>
					: <div className="no-video" />
				}
			</div>
		</section>
	)
}
export const query = graphql`
	fragment VideoHero on WpPage_Layout_block_Layout_VideoHero {
		fieldGroupName
		text
		button {
			target
			title
			url
		}
		title
		video {
			localFile {
				publicURL
			}
		}
	}
`